module.exports = __webpack_public_path__ + "img/logo2.5fc6f5a2.png";